import { z } from 'zod';
import { locales, type Locale } from '$lib/paraglide/runtime';

/** Kanoniczna kolejność kategorii — napędza sidebar i stronę główną wiki. */
export const WIKI_CATEGORIES = [
	'getting-started',
	'concepts',
	'features',
	'integrations',
	'faq'
] as const;
export type WikiCategory = (typeof WIKI_CATEGORIES)[number];

const localeSchema = z.custom<Locale>(
	(value) => typeof value === 'string' && (locales as readonly string[]).includes(value),
	'unsupported lang'
);

export const wikiFrontmatterSchema = z.object({
	/** Stały między językami — klucz łączący tłumaczenia tej samej strony. */
	pageId: z.string().regex(/^[a-z0-9-]+$/),
	title: z.string().min(1),
	description: z.string().min(1),
	category: z.enum(WIKI_CATEGORIES),
	order: z.number().int().min(0),
	lang: localeSchema,
	/** Natywny slug per język (PL: `koncepty/tracker`, nie `concepts/tracker`). */
	slug: z.string().regex(/^[a-z0-9-]+(\/[a-z0-9-]+)*$/),
	// Parser YAML mdsvexa oddaje datę jako Date albo pełny ISO string
	// ("2026-08-04T00:00:00.000Z") — normalizujemy do "YYYY-MM-DD".
	updated: z.preprocess(
		(value) => (value instanceof Date ? value.toISOString() : value),
		z
			.string()
			.regex(/^\d{4}-\d{2}-\d{2}(T[\d:.]+Z?)?$/)
			.transform((s) => s.slice(0, 10))
	)
});

export type WikiFrontmatter = z.infer<typeof wikiFrontmatterSchema>;

/** Strona wiki: frontmatter + ścieżka modułu Vite (klucz globów w content.ts). */
export interface WikiPage extends WikiFrontmatter {
	filePath: string;
}
